export default {
	message: {
		title: 'Messages',
		look_msg: 'View message',
		is_read: 'Status',
		read: 'Read',
		unread: 'Unread',
		msg_tilte: 'Title',
		send_at: 'Sent at',
		msg_type: 'Type',
		sys_msg: 'System message',
		ord_msg: 'Ordinary message',
	},
}
